module.exports = __webpack_public_path__ + "img/8.4924a096.png";